import { NgModule } from '@angular/core';
import {
  BrowserModule,
  provideClientHydration,
} from '@angular/platform-browser';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ContentComponent } from './layouts/content/content.component';
import { FullComponent } from './layouts/full/full.component';
import { HeaderComponent } from './shared/components/header/header.component';
import { provideHttpClient } from '@angular/common/http';
import { AuthGuard } from './shared/auth/auth.guard';
import { isLoggedIn } from './shared/auth/isLogin.guard';
import { ToastrModule } from 'ngx-toastr';

@NgModule({
  declarations: [AppComponent, FullComponent, ContentComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HeaderComponent,
    ToastrModule.forRoot({
      timeOut: 10000,
      positionClass: 'toast-bottom-right',
    }),
  ],
  providers: [
    provideClientHydration(),
    provideHttpClient(),
    AuthGuard,
    isLoggedIn,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
